import { MemberStatus } from '@tribeplatform/gql-client/types'
import { T } from '@tribeplatform/react-components/i18n'
import { useAuthMember } from '@tribeplatform/react-sdk/hooks'
import { Card } from '@tribeplatform/react-ui-kit/Card'

import { EmailVerificationForm } from '../Auth/Forms/EmailVerificationForm.js'

export const VerifyAccount = () => {
  const { data: member } = useAuthMember()

  if (!member || member?.status === MemberStatus.VERIFIED) {
    return null
  }

  return (
    <Card>
      <Card.Header
        title={
          <T
            defaultMessage="Account verification"
            id="Accounts.Settings.Verification"
          />
        }
      />
      <Card.Content>
        <EmailVerificationForm />
      </Card.Content>
    </Card>
  )
}
